import AccountingIcon from './icons/Accounting.png';
import AccountsIcon from './icons/Accounts.png';
import BusinessesIcon from './icons/Businesses.png';
import CalendarIcon from './icons/Calendar.png';
import CallsIcon from './icons/Calls.png';
import CasesIcon from './icons/Cases.png';
import ContactIcon from './icons/Contacts.png';
import InvoiceIcon from './icons/Invoices.png';
import LeadsIcon from './icons/Leads.png';
import NotesIcon from './icons/Notes.png';
import OpportunitiesIcon from './icons/Opportunities.png';
import ProductIcon from './icons/Products.png';
import ProjectIcon from './icons/Projects.png';
import PurchaseOrderIcon from './icons/PurchaseOrders.png';
import QuotesIcon from './icons/Quotes.png';
import SettingsIcon from './icons/Settings.png';
import SupportIcon from './icons/Support.png';
import TaskIcon from './icons/Tasks.png';

const moduleIconMap = {
  'Contacts': ContactIcon,
  'Accounts': AccountsIcon,
  'Leads': LeadsIcon,
  'Opportunities': OpportunitiesIcon,
  'Calls': CallsIcon,
  'Cases': CasesIcon,
  'Tasks': TaskIcon,
  'Meetings': CalendarIcon,
  'Notes': NotesIcon,
  'Project': ProjectIcon,
  'AOS_Products': ProductIcon,
  'AOS_Quotes': QuotesIcon,
  'AOS_Invoices': InvoiceIcon,
  'jcrm_Businesses': BusinessesIcon,
  'jcrm_PurchaseOrders': PurchaseOrderIcon,
  'jcrm_Accounting': AccountingIcon,
  'Support': SupportIcon,
};

export function getModuleIconSrc(moduleName) {
  return moduleIconMap[moduleName] || null;
}

export function ModuleIcon({ moduleName, fallback, className = 'module-png-icon' }) {
  const src = moduleIconMap[moduleName];
  if (src) {
    return <img src={src} alt={moduleName} className={className} />;
  }
  return fallback || null;
}

export {
  AccountingIcon,
  AccountsIcon,
  BusinessesIcon,
  CalendarIcon,
  CallsIcon,
  CasesIcon,
  ContactIcon,
  InvoiceIcon,
  LeadsIcon,
  NotesIcon,
  OpportunitiesIcon,
  ProductIcon,
  ProjectIcon,
  PurchaseOrderIcon,
  QuotesIcon,
  SettingsIcon,
  SupportIcon,
  TaskIcon,
};
